import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { addTerminalMasterApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const addTerminalMaster = createAsyncThunk('addTerminalMaster', async (payload) => {
  return await addTerminalMasterApi(payload);
});

const addTerminalMasterSlice = createSlice({
  name: 'addTerminalMaster', // Unique Name
  initialState,
  reducers: {
    addTerminalMasterReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addTerminalMaster.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(addTerminalMaster.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(addTerminalMaster.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { addTerminalMasterReset } = addTerminalMasterSlice.actions;

export default addTerminalMasterSlice.reducer;
